import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 768px)', width: '60vw' }]

export default function LianaTablet(): React.ReactElement {
  const { t } = useTranslation(['drill'])

  return (
    <ResponsiveImage
      alt={t('drill:imageAlt.beanStalkTablet')}
      fit="cover"
      height={1002}
      imageClassName="absolute -top-72 -left-28 max-w-none w-[820px]"
      loading="eager"
      mediaQuery={mediaQuery}
      srcKey="math-drills/index/beanstalk-tablet.png"
      width={820}
    />
  )
}
